import { List, Pagination, type ListProps } from 'react-admin';
import { ListActions } from './ListActions';

/** Preserve React Admin URL state, query cache and server pagination. */
export function AdminList(props: ListProps) {
  return <List perPage={25} pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
    actions={<ListActions />} {...props} />;
}
